import { render, staticRenderFns } from "./ExpandableOptions.vue?vue&type=template&id=1970995e&scoped=true&"
import script from "./ExpandableOptions.vue?vue&type=script&lang=js&"
export * from "./ExpandableOptions.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableOptions.vue?vue&type=style&index=0&id=1970995e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970995e",
  null
  
)

export default component.exports